import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  height: 296px;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--base-gray20, #dedede);
  background: var(--base-white50, rgba(255, 255, 255, 0.5));
  flex-direction: column;
`

const Row = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
`

const Column = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #262626;
  background: var(--secondary10, #eef1f9);
  border: 1px solid var(--base-gray10, #e8e8e8);
`

const Cell = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--base-gray20, #e8e8e8);
  color: #404040;
`

interface Props {
  대전Data: any
  보령Data: any
  여수Data: any
  정읍Data?: any
}

const Page1Table = (props: Props) => {
  const { 대전Data, 보령Data, 여수Data, 정읍Data } = props

  return (
    <Wrapper>
      <Row>
        <Column>마을명</Column>
        <Column>정읍</Column>
        <Column>대전</Column>
        <Column>보령</Column>
        <Column>여수</Column>
      </Row>
      <Row>
        <Cell>에너지 자립률 [%]</Cell>
        <Cell>{Number(정읍Data?.substitutionRate) || 0}</Cell>
        <Cell>{Number(대전Data?.substitutionRate) || 0}</Cell>
        <Cell>{Number(보령Data?.substitutionRate) || 0}</Cell>
        <Cell>{Number(여수Data?.substitutionRate) || 0}</Cell>
      </Row>
      <Row>
        <Cell>발전량 [MWh]</Cell>
        <Cell>
          {Number(정읍Data?.genSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.genSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.genSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.genSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>전력 사용량 [MWh]</Cell>
        <Cell>
          {Number(정읍Data?.usgSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.usgSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.usgSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.usgSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>발전판매요금 [원]</Cell>
        <Cell>
          {Number(
            정읍Data?.beforeTradeCharge?.toFixed(0) || 0
          )?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(
            대전Data?.beforeTradeCharge?.toFixed(0) || 0
          )?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(
            보령Data?.beforeTradeCharge?.toFixed(0) || 0
          )?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(
            여수Data?.beforeTradeCharge?.toFixed(0) || 0
          )?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>전력사용 요금 [원]</Cell>
        <Cell>
          {Number(정읍Data?.usgChargeSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.usgChargeSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.usgChargeSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.usgChargeSum?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
      <Row>
        <Cell>요금 합계 [원]</Cell>
        <Cell>
          {Number(정읍Data?.beforeBenefit?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(대전Data?.beforeBenefit?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(보령Data?.beforeBenefit?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
        <Cell>
          {Number(여수Data?.beforeBenefit?.toFixed(0) || 0)?.toLocaleString()}
        </Cell>
      </Row>
    </Wrapper>
  )
}

export default Page1Table
